module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/maja-2d3b7e6b8860385e2c9f9a00fdbcf7a8.webp";